import styled from 'styled-components'
import ColorPalette from '~/styles/colorPalette'

export const Card = styled.div`
  width: 100%;
  min-height: 136px;
  padding: 16px;
  gap: 16px;
  flex-shrink: 0;
  border-radius: 6px;
  background: #fff;
  display: flex;
  flex-direction: row;
  outline: 1px solid #c9c9cb;

  &:hover {
    outline: 2px solid ${({ theme }) => theme.colors.cyanBlueInputBorder};
  }
`

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 104px;
  height: 104px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  color: ${ColorPalette.white};
`

export const AvatarInitials = styled.span`
  font-family: Barlow, sans-serif;
  font-size: 32px;
  line-height: 48px;
  font-weight: 600;
`

export const AvatarPhoto = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
`

export const ContactTitle = styled.h2`
  color: #000;
  font-family: Barlow;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
  margin: 0;
`

export const ContactSubTitle = styled.h3`
  color: #006bff;
  font-family: Barlow;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px; /* 150% */
  margin: 0 0 4px;
`

export const ContactContent = styled.address`
  color: #303032;
  font-family: Barlow;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  margin: 0;

  a {
    color: #303032;
  }
`

export const PhoneIcon = styled.img`
  width: 14px;
  height: 14px;
  margin-left: 2px;
  margin-bottom: 2px;
  object-fit: cover;
`

export const Details = styled.div`
  word-break: break-word;
`
